module.exports = __webpack_public_path__ + "assets/bac35e67518259af9a9a9e2e05719f42.mp3";